import { render, staticRenderFns } from "./ProductValueHelp.vue?vue&type=template&id=4655b3d0&"
import script from "./ProductValueHelp.vue?vue&type=script&lang=js&"
export * from "./ProductValueHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports